import createLucideIcon from '../createLucideIcon';

const ArrowRightToLine = createLucideIcon('ArrowRightToLine', [
  ['line', { x1: '17', x2: '3', y1: '12', y2: '12', key: '1qcq2n' }],
  ['polyline', { points: '11 18 17 12 11 6', key: 'hrgmhe' }],
  ['path', { d: 'M21 5v14', key: 'nzette' }],
]);

export default ArrowRightToLine;
